










import { Vue, Component } from 'vue-property-decorator';
import ListadoEjecutivos from '@/pantallas/SucursalVirtual/ListadoEjecutivos/ListadoEjecutivos.vue';

@Component({
  components: {
    ListadoEjecutivos,
  },
})
export default class ListadoEjecutivosPantalla extends Vue {}
